/* ll-stack.js — de meter van de trapkorting.
 *
 * Nagebouwd uit `assets/stack-save.js` van de bron. De logica in het kort:
 *   bereikt  = hoogste trede waar het HUIDIGE aantal aan voldoet
 *   voorproef = hoogste trede waar aantal + 1 aan voldoet
 * De balk vult tot de hoogste van die twee, de punt van de voorproef krijgt een
 * ring, en de zin eronder vertelt wat één artikel extra oplevert.
 *
 * De teller komt van drie kanten: het serverkant meegegeven `data-start`, een
 * `fetch('/cart.js')`, en de gebeurtenissen die de wagen uitstuurt. Horizon
 * gebruikt andere gebeurtenisnamen dan het andere thema, dus die staan hieronder
 * allemaal aangehaakt.
 */
(() => {
  let laatste = null;

  const tredes = (el) => {
    try { return JSON.parse(el.getAttribute('data-tredes')); }
    catch (e) { return [{q:1,d:0},{q:2,d:10},{q:3,d:15},{q:4,d:20},{q:5,d:25}]; }
  };

  function teken(el, aantal) {
    const t = tredes(el), totaal = t.length, volgende = aantal + 1;
    let bereikt = -1, voorproef = -1;
    for (let i = 0; i < totaal; i++) {
      if (aantal >= t[i].q) bereikt = i;
      if (volgende >= t[i].q) voorproef = i;
    }
    const balkIdx = Math.max(bereikt, voorproef, 0);
    const pct = balkIdx <= 0 ? 0 : (balkIdx / (totaal - 1)) * 100;

    const vulling = el.querySelector('[data-ll-stack-vulling]');
    if (vulling) vulling.style.width = Math.min(100, pct) + '%';

    el.querySelectorAll('[data-ll-stack-punt]').forEach((punt, i) => {
      punt.classList.remove('is-bereikt', 'is-voorproef');
      if (i <= bereikt) punt.classList.add('is-bereikt');
      else if (i === voorproef && voorproef > bereikt) punt.classList.add('is-voorproef');
    });
    el.querySelectorAll('[data-ll-stack-label]').forEach((label, i) => {
      label.classList.toggle('is-voorproef', i === voorproef && voorproef > bereikt);
    });

    const stand = el.querySelector('[data-ll-stack-stand]');
    if (stand) stand.textContent = 'Bag: ' + aantal + ' ' + (aantal === 1 ? 'item' : 'items');

    const zin = el.querySelector('[data-ll-stack-zin]');
    if (!zin) return;
    if (voorproef > bereikt) {
      const d = t[voorproef].d;
      zin.innerHTML = d > 0
        ? 'Adding this unlocks <strong>' + d + '% off your bag</strong>'
        : 'Add one more to unlock <strong>' + t[1].d + '% off</strong>';
    } else if (volgende >= t[totaal - 1].q) {
      zin.innerHTML = "You're at the top tier — <strong>" + t[totaal - 1].d + '% off locked in</strong>';
    } else {
      zin.innerHTML = 'Add one more to unlock <strong>' + t[1].d + '% off</strong>';
    }
  }

  function tekenAlles(aantal) {
    laatste = aantal;
    document.querySelectorAll('[data-ll-stack]').forEach((el) => teken(el, aantal));
  }

  function vanServer() {
    const el = document.querySelector('[data-ll-stack]');
    if (!el) return;
    const n = parseInt(el.getAttribute('data-start'), 10);
    if (!isNaN(n)) tekenAlles(n);
  }

  function vanWagen() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then((r) => (r.ok ? r.json() : null))
      .then((wagen) => { if (wagen && typeof wagen.item_count === 'number') tekenAlles(wagen.item_count); })
      .catch(() => {});
  }

  function opGebeurtenis(ev) {
    const w = ev && ev.detail && (ev.detail.cart || ev.detail.newCart || ev.detail);
    if (w && typeof w.item_count === 'number') tekenAlles(w.item_count);
    else vanWagen();
  }

  vanServer();
  vanWagen();

  /* Horizon heeft GEEN wagen-gebeurtenis in `ThemeEvents` — die lijst kent
     alleen media, aantalkiezer, megamenu en zoom. De wagen wordt ververst door
     secties opnieuw te renderen.

     HIER STOND EEN PEILING: na elke klik op een koop- of wagenknop twee keer
     `/cart.js` ophalen (op 600 en 1600ms), plus een waarnemer op het telletje
     bij het wagenicoon. Dat was nodig zolang er geen betrouwbaar signaal was.

     Dat signaal is er nu wel. `ll-cart.js` lapt `window.fetch` om en meldt
     `ll:wagen-gewijzigd` zodra het antwoord op een wagenmutatie ECHT binnen
     is. Dat is preciezer dan een klok: op een trage verbinding was 600ms te
     vroeg, en bij een snelle klik werd er twee keer voor niets opgehaald.

     Let op de volgorde van de meting die hieraan voorafging: Shopify's eigen
     `shopify:cart:lines-update` vuurt TE VROEG — op dat moment gaf `/cart.js`
     nog de oude stand. Daarom hangt de meter aan onze eigen melding en niet
     aan die van Shopify. */
  document.addEventListener('ll:wagen-gewijzigd', () => vanWagen());

  document.addEventListener('shopify:section:load', () => { if (laatste !== null) tekenAlles(laatste); else vanServer(); });
})();
